import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ExcepcionGMFTipoCredito } from '../_models/excepcion-gmf-tipo-credito';

@Injectable({
  providedIn: 'root'
})
export class ExcepcionGMFTipoCreditoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/excepcionesGMFTiposCreditos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ExcepcionGMFTipoCredito [] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ExcepcionGMFTipoCredito [] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ExcepcionGMFTipoCredito ) );
  }

  crear( regCrear: ExcepcionGMFTipoCredito ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ExcepcionGMFTipoCredito ) );
  }

  actualizar( regActualizar: ExcepcionGMFTipoCredito ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regActualizar ).pipe( map( res => res as ExcepcionGMFTipoCredito ) );
  }

  obtenerPorIdExcepcionGMF( id: string ) {
    return this.httClient.get( this.rutServicio + '/excepcion/' + id ).pipe( map( res => res as ExcepcionGMFTipoCredito ) );
  }

  obtenerPorIdExcepcionGMFHabilitado( id: string ) {
    return this.httClient.get( this.rutServicio + '/excepcion/' + id + '/enabled' ).pipe( map( res => res as ExcepcionGMFTipoCredito ) );
  }

}
